import { PromoCodeBonus } from "services/bonus/type"

import { getDisplayName } from "./bonus2.helpers"

/** RFC 4180 quoting — a bonus name can contain a comma or a quote. */
const cell = (value: string | number | null | undefined): string => {
  const s = value === null || value === undefined ? "" : String(value)
  return /[",\n]/.test(s) ? `"${s.replace(/"/g, '""')}"` : s
}

const slug = (value: string): string =>
  value
    .toLowerCase()
    .trim()
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-+|-+$/g, "") || "bonus"

const save = (rows: (string | number)[][], filename: string) => {
  const blob = new Blob([rows.map((r) => r.map(cell).join(",")).join("\r\n")], { type: "text/csv;charset=utf-8;" })
  const url = window.URL.createObjectURL(blob)
  const link = document.createElement("a")
  link.href = url
  link.setAttribute("download", filename)
  document.body.appendChild(link)
  link.click()
  document.body.removeChild(link)
  window.URL.revokeObjectURL(url)
}

const today = (): string => new Date().toISOString().slice(0, 10)

/** The codes as a bare list — what the editor offers once they are stored. */
export const downloadPromoCodesCsv = (codes: string[], bonusName?: string): void => {
  if (codes.length === 0) return
  save(
    [["code"], ...codes.map((c) => [c])],
    `promo-codes-${slug(bonusName || "bonus")}-${today()}.csv`
  )
}

/** One bonus's codes with their state, exported from the Promo Codes tab. */
export const downloadPromoCodeRowsCsv = (rows: PromoCodeBonus[], bonusName: string): void => {
  if (rows.length === 0) return
  save(
    [
      ["code", "bonus", "status", "redemptions", "created_at"],
      ...rows.map((r) => [
        r.promo_code,
        getDisplayName(r.name),
        r.codeArchived ? "archived" : r.codeActive ? "active" : "inactive",
        r.redemptionCount,
        r.createdAt ?? ""
      ])
    ],
    `promo-codes-${slug(bonusName)}-${today()}.csv`
  )
}
